<template>
  <div>
    <highcharts :constructorType="'stockChart'" class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>

import renew from '../assets/renew'
import reactivate from '../assets/reactivate'


export default {
  data() {    
    return {
      chartOptions: {}
    };
  },  
  created: function () {
    // `this` points to the vm instance
    this.chartOptions = {
        title: {
          text: 'Subscription Charts'
        },
        rangeSelector: {
            allButtonsEnabled: true,
            buttons: [{
                type: 'day',
                count: 1,
                text: 'Day'
            }, {
                type: 'week',
                count: 1,
                text: 'Week'
            }, {
                type: 'month',
                count: 1,
                text: 'Month'
            }, {
                type: 'month',
                count: 3,
                text: '3 Month'
            }, {
                type: 'month',
                count: 6,
                text: '6 Month'
            }, {
                type: 'year',
                count: 1,
                text: 'Year'
            }],            
            buttonTheme: {
                width: 60
            },            
            selected: 4,
        },

        yAxis: {
            opposite: false,
        },

        legend: {
          enabled: true,
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom'
        },  

        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
            valueDecimals: 2,
            split: true
        },

        series: [
          {
            name: "Reactivated Subscriptions",
            data: renew,
            marker: {
                enabled: true,
                radius: 3
            },
            shadow: true,
          },
          {
            name: "Renewed Subscriptions",
            data: reactivate,
            marker: {
                enabled: true,
                radius: 3
            },
            shadow: true,
          },          
        ]
      }
  }  
};
</script>
